<template>
    <div>

        <!-- Form Submit Review -->
        <div class="review-modal review-modal-form">

            <div class="review-modal-shade"></div>

            <div class="review-modal-main">

            <span class="review-modal-close">
                <svg class="close"><use xlink:href="#close"></use></svg>
            </span>
                <div class="review-modal-form">

                    <div class="review-modal-intro">
                        <svg class="review-add"><use xlink:href="#review-add"></use></svg>
                        <h2>What did you think of <span v-text="`${spot.title}?`"></span></h2>
                    </div>
                    <div class="review-modal-intro alt">
                        <svg class="check"><use xlink:href="#check"></use></svg>
                        <h2>Endorsed!</h2>
                        <h3>Would you like to leave a review?</h3>
                    </div>

                    <form action="" method="post" @submit.prevent="submit">

                        <!-- Sentiment Radio Input -->
                        <div class="review-modal-rating">
                            <div class="check-wrap" :class="{'dis' : (form.sentiment != 'Loved It' && form.sentiment != null)}">
                                <input
                                    v-model="form.sentiment"
                                    type="radio"
                                    class="js-sentiment"
                                    id="rating-love"
                                    value="Loved It"
                                    name="sentiment">
                                <label for="rating-love">Loved It</label>
                            </div>
                            <div class="check-wrap" :class="{'dis' : (form.sentiment != 'Liked It' && form.sentiment != null)}">
                                <input
                                    v-model="form.sentiment"
                                    type="radio"
                                    class="js-sentiment"
                                    id="rating-like"
                                    value="Liked It"
                                    name="sentiment">
                                <label for="rating-like">Liked It</label>
                            </div>
                            <div class="check-wrap" :class="{'dis' : (form.sentiment != 'Pass' && form.sentiment != null)}">
                                <input
                                    v-model="form.sentiment"
                                    type="radio"
                                    id="rating-pass"
                                    class="js-sentiment"
                                    value="Pass"
                                    name="sentiment">
                                <label for="rating-pass">Pass</label>
                            </div>
                        </div>
                        <!--                    <div class="error" v-if="form.errors.sentiment" v-text="form.errors.sentiment"></div>-->

                        <!-- Traits -->
                        <div v-if="traits.length" class="review-modal-options">

                            <!-- Likes -->

                            <div class="col" id="review-likes">
                                <h3>What did you like about it?</h3>

                                <span v-for="(trait, index) in traits"
                                      :key="`review-trait-${index}-like`"
                                      :id="`likes-${trait.id}`"
                                      :class="traitClass(trait, 'like')">

                                <input
                                    type="checkbox"
                                    @click="updateTraits(trait, 'like')"
                                    :value="{id: trait.id, value: 'like'}"
                                    class="js-trait">
                                <label :for="`likes-${trait.name}`" v-text="trait.name"></label>
                            </span>
                            </div>

                            <!-- Dislikes -->
                            <div class="col" id="review-dislikes">
                                <h3>What needs improvement?</h3>

                                <span v-for="(trait, index) in traits"
                                      :key="`review-trait-${index}-dislike`"
                                      :id="`dislikes-${trait.id}`"
                                      :class="traitClass(trait, 'dislike')">

                                    <input
                                        type="checkbox"
                                        @click="updateTraits(trait, 'dislike')"
                                        :value="{id: trait.id, value: 'dislike'}"
                                        class="js-trait">
                                    <label :for="`dislikes-${trait.name}`" v-text="trait.name"></label>
                            </span>
                            </div>
                        </div>

                        <!-- Review Text -->
                        <div class="review-modal-comments">
                            <h3>Care to elaborate?</h3>
                            <label for="review-comments">Review Comments</label>
                            <textarea v-model="form.comments" id="review-comments" name="review-comments"></textarea>
                        </div>

                        <!-- Photos -->
                        <div class="review-modal-photos form__row__right" id="js-dropzone">
                            <UploadPhotos v-model="form.images" @uploadImagesStatus="isUploadingImages = $event"></UploadPhotos>
                        </div>

                        <!-- Submit Button -->
                        <button class="review-modal-submit"
                                type="submit"
                                :class="{'disabled': (isDisabled || isUploadingImages) }"
                                :disabled="form.isSubmitted || isUploadingImages">
                            Submit
                            <svg class='arrow-right'><use xlink:href="#arrow-right"></use></svg>
                        </button>
                    </form>
                </div>
            </div>
        </div>

        <!-- Form Dialog Processing -->
        <div class="review-modal review-modal-processing-request">
            <div class="review-modal-shade"></div>
            <div class="review-modal-main">
                <span class="review-modal-close">
                    <svg class="close"><use xlink:href="#close"></use></svg>
                </span>
                <div class="review-modal-loading is-active">
                    <div class="spinner"></div>
                </div>
                <div>Just hang tight, we're submitting your review!</div>
            </div>
        </div>

        <!-- Form Thank You -->
        <div class="review-modal review-modal-thank-you">
            <div class="review-modal-shade"></div>
            <div class="review-modal-main">
                <span class="review-modal-close">
                    <svg class="close"><use xlink:href="#close"></use></svg>
                </span>
                <div class="review-modal-outro">
                    <svg class="review-add"><use xlink:href="#review-add"></use></svg>
                    <h2>Thanks for your review!</h2>
                    <p>You’ve got great taste.</p>
                    <span class="review-modal-close take-me" @click="closeModal()">
                        See my review
                        <svg class='arrow-right'><use xlink:href="#arrow-right"></use></svg>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Helpers from '@/mixins/Helpers';
import Alert from '@/classes/Alert';
import Form from '@/classes/Form';
import UploadPhotos from '@/components/FormDropzone';

export default {

    mixins:[Helpers],

    props: ['spot', 'traits', 'lovedByUsers', 'reviewUrl'],

    components: {
        UploadPhotos
    },

    data() {
        return {
            isUploadingImages: false,
            spotSubmittedSuccess: false,
            form: new Form({
                sentiment: null,
                traits: [],
                images: [],
                comments: '',
            }),
        }
    },

    mounted() {
        this.registerListeners()
    },

    methods: {

        submit() {
            $('.review-modal-form').fadeOut()
            $('.review-modal-processing-request').fadeIn()
            this.form.post(this.reviewUrl || `/spot/${this.spot.slug}/reviews`)
                .then(response => {
                    $('.review-modal-processing-request').fadeOut()
                    $('.review-modal-thank-you').fadeIn()
                    this.spotSubmittedSuccess = true
                    eventBus.$emit('new-review', response.review)
                    eventBus.$emit('reset-form-dropzone')
                })
                .catch(errors => {
                    $('.review-modal-processing-request').fadeOut()
                    $('.review-modal-form').fadeIn()
                    Alert.error(this.form.errors.first())
                })
        },

        updateTraits(trait, value) {

            let oppositive = value == 'like' ? 'dislike' : 'like';

            let index = this.form.traits.findIndex(t => {
                return t.id == trait.id
            })
            let exists = index > -1;

            let oppositiveValue = this.form.traits.findIndex(t => {
                return t.id == trait.id && t.value == oppositive
            })
            let existsOppositive = oppositiveValue > -1;

            if (exists && existsOppositive) {
                this.form.traits.splice(index, 1)
                this.form.traits.push({
                    id: trait.id,
                    value: value,
                })
            } else if (exists && !existsOppositive) {
                this.form.traits.splice(index, 1)
            } else {
                this.form.traits.push({
                    id: trait.id,
                    value: value,
                })
            }
        },

        isTraitSelected(trait, value) {
            return _.find(this.form.traits, t => {
                return (t.id == trait.id && t.value == value)
            })
        },

        isOpositiveSelected(trait, value) {
            let opositive = value == 'like' ? 'dislike' : 'like';
            return this.form.traits.findIndex(t => {
                return t.id == trait.id && t.value == opositive
            }) > -1
        },

        traitClass(trait, value) {
            let isSelected = this.isTraitSelected(trait, value);
            let isOpositiveSelected = this.isOpositiveSelected(trait, value)
            return {'active': isSelected, 'dis': isOpositiveSelected}
        },

        registerListeners() {
            $('.reviews-modal-trigger').on('click', () => {
                $('.review-modal-form').fadeIn()
            })
            $('.review-modal-close, .review-modal-shade').on('click', () => {
                $('.review-modal').fadeOut()
                eventBus.$emit('reset-form-dropzone')
            })
        },

        resetForm(){
            this.form.sentiment = null
            this.form.traits = []
            this.form.comments = ''
            this.form.images = []
        },

        closeModal() {
            $('.review-modal').fadeOut()
            this.resetForm()
        }
    },

    computed: {
        isDisabled() {
            if (this.form.sentiment == null) {
                return true;
            }
            return false;
        }
    }
}
</script>
